import React from "react";
import { Table } from "../../../components/CustomPaginations";
import { tableStyle } from "../../../components/TableStyle";
const TotalHoursTable = (props) => {
	return (
		<>
			<Table
				inputValue={""}
				keyField={"taskCategory"}
				columns={props.columns}
				items={props.totalProjectHours}
				tableStyle={tableStyle}
				onTablePageChange={props.handleTableChange}
				defaultSorted={props.defaultSorted}
				showFeedback={false}
				tableLoader={props.isLoading}
				loading={props.isLoading}
				SearchBar={() => {
					return null;
				}}
				receiveData={(PageSize) => {
					props.receiveData(PageSize);
				}}
				flag={props.flag}
				totalHours={props.totalHours}
			/>
		</>
	);
};

export default TotalHoursTable;
